import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import localeHu from '@angular/common/locales/hu';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';

// A LOCALE_ID provider mellett itt regisztráljuk a locale adatokat is, hogy a kettő
// ne csúszhasson szét: így a magyar dátumformátum a bootstrapen kívül (pl. tesztben) is működik.
registerLocaleData(localeHu, 'hu');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      // A :slug útvonal-paramétert közvetlenül a komponens input()-jára kötjük.
      withComponentInputBinding(),
      // Hír megnyitásakor a lap tetejére ugrunk, vissza lépve visszaáll a pozíció.
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
    ),
    provideHttpClient(withFetch()),
    provideAnimations(),
    // A magyar dátumformátumhoz, pl. „2025. augusztus 2.”.
    { provide: LOCALE_ID, useValue: 'hu' },
    { provide: APP_BASE_HREF, useValue: '/' }
  ]
};
